<template>
  <Modal
    v-if="isOpen"
    title="Shared vs Private Flows"
    size="smallish"
    @close="$emit('close')"
  >
    <div class="space-y-4 text-sm pb-4">
      <p>
        We have made some updates to Flows, which means Flows can now be accessed by your app's Shared Builders.
      </p>
      <div>
        <p class="font-semibold">
          Private Flows
        </p>
        <p class="mt-1">
          All existing Flows or Linked Apps you created prior to the latest deploy will be shown in the Private area.
          These are only visible to you. To make these Flows or Linked Apps accessible to your app's shared builders,
          you'll need to recreate them in the Shared area.
        </p>
      </div>
      <div>
        <p class="font-semibold">
          Shared Flows
        </p>
        <p class="mt-1">
          In the Shared area you can see Flows and Linked Apps which are accessible by this app's Shared Builders.
          The Flows and Linked Apps set up in this area are specific to the app you are currently editing.
        </p>
      </div>
      <div>
        <p class="font-semibold">
          Need help recreating Flows or setting up Linked Apps?
        </p>
        <p class="mt-1">
          Our Knowledge Base explains more about how to create Flows.
          <a
            href="https://docs.knack.com/docs/flows-getting-started"
            target="_blank"
            rel="noreferrer"
            class="text-brand-default underline"
          >
            Knowledge Base
          </a>
        </p>
        <p class="mt-1">
          If you need help recreating your Flows in the Shared area,
          <a
            href="mailto:support@knack.com"
            class="text-brand-default underline"
          >
            contact our support team
          </a>.
        </p>
      </div>
    </div>

    <template #footer>
      <div class="flex items-center w-full">
        <a
          href="https://docs.knack.com/docs/flows-getting-started"
          target="_blank"
          rel="noreferrer"
          class="mr-auto inline-flex items-center text-sm text-brand-default underline"
        >
          Learn More
        </a>
        <button
          type="button"
          class="bg-transparent text-sm px-4 py-2 rounded border-none hover:bg-muted"
          @click="$emit('close')"
        >
          Close
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/ui/Modal.vue';

export default {
  name: 'SharedVsPrivateModal',
  components: { Modal },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
};
</script>
